import React from "react";
import { createPortal } from "react-dom";

import { DROPDOWN_MENU_PORTAL_ID } from "./constants";
import { StyledMenuWrapper } from "./styles";

export const DropdownMenuPortal = () => {
  return createPortal(
    <StyledMenuWrapper className="ignore-onclickoutside" id={DROPDOWN_MENU_PORTAL_ID} />,
    document.body
  );
};
